import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/mobile.css'
import App from './App.vue'
import router from './router'
import request from './api'
import VueClipboard from 'vue-clipboard2'
import * as pagePerm from '@/utils/pagePerm'
import UserPicker from '@/views/components/UserPicker.vue'

Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.component('UserPicker', UserPicker)

Vue.prototype.$http = request

// ========== 角色页面权限门禁（角色 × 页面 × 增删改查），全局可用 ==========
Vue.mixin({
  methods: {
    $canView(key) { return pagePerm.canView(key) },
    $canAdd(key) { return pagePerm.canAdd(key) },
    $canEdit(key) { return pagePerm.canEdit(key) },
    $canDelete(key) { return pagePerm.canDelete(key) }
  }
})

// ========== 当前登录供应商ID（供应商门户数据隔离用） ==========
Vue.prototype.$supplierId = function () {
  try {
    const s = JSON.parse(localStorage.getItem('supplier_info') || '{}')
    return s && s.id ? s.id : null
  } catch (e) { return null }
}

// ========== 当前登录用户ID（后台审批/日程归属用） ==========
Vue.prototype.$currentUserId = function () {
  try {
    const u = JSON.parse(localStorage.getItem('userInfo') || '{}')
    return u && u.id ? u.id : null
  } catch (e) { return null }
}

// ========== 关键操作双人复核（安全风控）：发起复核申请，返回 {required, confirmId} ==========
// required=true → 已提交复核待第二人审批；required=false → 可直接执行原操作
Vue.prototype.$dualApply = function (bizType, targetId, targetDesc, actionParams) {
  return this.$http.post('/approval/dualConfirmApply', {
    bizType, targetId, targetDesc, actionParams: actionParams || ''
  })
}

// ========== 全局权限检查方法 ==========
Vue.prototype.$hasPermission = function(permId) {
  const viewPermission = parseInt(localStorage.getItem('viewPermission') || '1')
  if (viewPermission >= 3) return true
  const perms = JSON.parse(localStorage.getItem('userPermissions') || '[]')
  if (perms.includes(permId)) return true
  return perms.some(p => p.startsWith(permId + '_'))
}

Vue.prototype.$hasOp = function(permId, op) {
  // 检查具体操作权限，如 $hasOp('p_bidding_project', 'add')
  const viewPermission = parseInt(localStorage.getItem('viewPermission') || '1')
  if (viewPermission >= 3) return true
  const perms = JSON.parse(localStorage.getItem('userPermissions') || '[]')
  return perms.includes(permId + '_' + op)
}

Vue.config.productionTip = false


// ========== 全局工具方法（供 el-table :formatter 使用） ==========
Vue.prototype.$formatTime = function (row, column, cellValue) {
  if (!cellValue) return ''
  try {
    var d = new Date(cellValue)
    if (isNaN(d.getTime())) return cellValue
    var y = d.getFullYear()
    var m = String(d.getMonth() + 1).padStart(2, '0')
    var day = String(d.getDate()).padStart(2, '0')
    var h = String(d.getHours()).padStart(2, '0')
    var min = String(d.getMinutes()).padStart(2, '0')
    var s = String(d.getSeconds()).padStart(2, '0')
    return y + '年' + m + '月' + day + '日 ' + h + ':' + min + ':' + s
  } catch (e) { return cellValue }
}
Vue.prototype.$formatGender = function (row, column, cellValue) {
  if (cellValue === 0 || cellValue === '0') return '男'
  if (cellValue === 1 || cellValue === '1') return '女'
  return cellValue || ''
}

// ========== 附件地址归一化 + 新窗口打开（合同/发票 PDF 通用） ==========
// 🔴 2026-09-22：URL 有两种形态，必须都兼容——
//   ① 老系统公网地址 http://101.201.154.95:3003/storage/avatars/xxx.pdf（707 条采购）
//   ② 本地相对路径 /uploads/xxx.pdf（9 条，nginx 已配 location /uploads/）
// 另外 attachment 历史上有 JSON 数组字符串（"[\"url\"]"）的脏数据形态，需要拆。
Vue.prototype.$fileUrl = function (path) {
  if (!path) return ''
  if (Array.isArray(path)) {
    const first = path.find(p => p)
    return first ? this.$fileUrl(first) : ''
  }
  if (typeof path !== 'string') return ''
  const s = path.trim()
  if (!s) return ''
  if (s.startsWith('[')) {
    try {
      const arr = JSON.parse(s)
      if (Array.isArray(arr) && arr.length) return this.$fileUrl(arr[0])
    } catch (e) {}
    const m = s.match(/["'](https?:\/\/[^"']+)["']/)
    return m ? this.$fileUrl(m[1]) : ''
  }
  if (/^https?:\/\//i.test(s)) return s
  return window.location.origin + (s.startsWith('/') ? '' : '/') + s
}
Vue.prototype.$openFile = function (path) {
  const url = this.$fileUrl(path)
  if (url) window.open(url, '_blank')
}

// 用户账号→姓名映射缓存（Layout.vue 登录后自动填充）
Vue.prototype._userNameMap = null
Vue.prototype.$displayName = function (row, column, cellValue) {
  if (!cellValue) return ''
  var val = String(cellValue)
  // 如果已经是中文名（包含中文字符），直接返回
  if (/[\u4e00-\u9fa5]/.test(val)) return val
  // 从全局用户映射中查找
  var map = Vue.prototype._userNameMap
  if (!map) return val
  // 支持逗号分隔的多用户ID（如验收人 1,2,3）
  if (val.indexOf(',') !== -1) {
    return val.split(',').map(function (id) { return map[id.trim()] || id.trim() }).join(', ')
  }
  return map[val] || val
}

// ========== 表格滚动同步（全平台） ==========
;(function initTableScrollAndDrag() {
  function bindScrollSync(table) {
    var headerW = table.querySelector('.el-table__header-wrapper')
    var bodyW = table.querySelector('.el-table__body-wrapper')
    if (!headerW || !bodyW) return
    if (bodyW._scrollSynced) return
    bodyW._scrollSynced = true

    // 水平同步 + 垂直同步（双向）
    var syncingH = false
    var syncingV = false

    bodyW.addEventListener('scroll', function () {
      if (syncingH) return
      syncingH = true
      headerW.scrollLeft = bodyW.scrollLeft
      syncingH = false
      
      if (syncingV) return
      syncingV = true
      var fixedBodyW = table.querySelector('.el-table__fixed-body-wrapper')
      if (fixedBodyW) fixedBodyW.scrollTop = bodyW.scrollTop
      syncingV = false
    }, { passive: true })

    headerW.addEventListener('scroll', function () {
      if (syncingH) return
      syncingH = true
      bodyW.scrollLeft = headerW.scrollLeft
      syncingH = false
    }, { passive: true })

    // 反向：fixed列滚动 → body
    var fixedBodyW = table.querySelector('.el-table__fixed-body-wrapper')
    if (fixedBodyW) {
      fixedBodyW.addEventListener('scroll', function () {
        if (syncingV) return
        syncingV = true
        bodyW.scrollTop = fixedBodyW.scrollTop
        syncingV = false
      }, { passive: true })
    }
  }

  // --- 鼠标拖拽左右滚动（不拦截滚动条） ---
  function bindMouseDrag(table) {
    var bodyW = table.querySelector('.el-table__body-wrapper')
    if (!bodyW || bodyW._dragBound) return
    bodyW._dragBound = true

    var isDown = false, startX = 0, startY = 0, scrollStartX = 0, scrollStartY = 0
    var hasDragged = false, DRAG_THRESHOLD = 5

    bodyW.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return
      // 点击滚动条时不拦截
      if (e.offsetX > bodyW.clientWidth || e.offsetY > bodyW.clientHeight) return
      isDown = true
      hasDragged = false
      startX = e.pageX
      startY = e.pageY
      scrollStartX = bodyW.scrollLeft
      scrollStartY = bodyW.scrollTop
    })

    bodyW.addEventListener('mousemove', function (e) {
      if (!isDown) return
      if (!hasDragged && Math.abs(e.pageX - startX) < DRAG_THRESHOLD && Math.abs(e.pageY - startY) < DRAG_THRESHOLD) return
      hasDragged = true
      bodyW.style.cursor = 'grabbing'
      bodyW.style.userSelect = 'none'
      bodyW.scrollLeft = scrollStartX - (e.pageX - startX)
      bodyW.scrollTop = scrollStartY - (e.pageY - startY)
    })

    function resetDrag() {
      isDown = false
      hasDragged = false
      bodyW.style.cursor = ''
      bodyW.style.userSelect = ''
    }
    bodyW.addEventListener('mouseup', resetDrag)
    bodyW.addEventListener('mouseleave', resetDrag)
  }

  function scanTables() {
    var tables = document.querySelectorAll('.el-table')
    for (var i = 0; i < tables.length; i++) {
      bindScrollSync(tables[i])
      bindMouseDrag(tables[i])
    }
  }

  var observer = new MutationObserver(function () { scanTables() })
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true })

  document.addEventListener('DOMContentLoaded', scanTables)
  window.addEventListener('hashchange', function () {
    var bodies = document.querySelectorAll('.el-table__body-wrapper')
    for (var i = 0; i < bodies.length; i++) {
      bodies[i]._scrollSynced = false
    }
    setTimeout(scanTables, 500)
  })
  setTimeout(scanTables, 1000)
})()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
